export default class Axis {
  public id: string;

  public label: string;

  constructor(obj: any = {}) {
    this.id = obj.id;
    this.label = obj.label || '';
  }
}
